<template>
    <div class="mood-meter">
        <img
            src="@/assets/icons/ic_pointer.svg"
            class="indicator"
            :style="`left: ${percent + 5}%;`"
        >

        <div class="meter"></div>

        <ul>
            <li>Sad</li>
            <li>Unpleasant</li>
            <li>Calm</li>
            <li>Pleasant</li>
            <li>Happy</li>
        </ul>
    </div>
</template>

<script>
export default {
	props: {
		percent: {
			type: Number,
			default: 0
		}
	}
}
</script>

<style lang="scss" scoped>
.mood-meter {
    .indicator {
        position: relative;
        width: 5%;
    }

    .meter {
        background-image: linear-gradient(45deg,#ca4f51,#eda05a 50%,#3dbfcd);
        width: 100%;
        height: 10px;
        border-radius: 5px;
    }

    ul {
        @include flex-row;

        li {
            text-align: center;
            padding: 5px;
            font-size: 1em;
            font-style: italic;
            color: $dark;
            width: 20%;
        }
    }
}
</style>
